<template>
  <div>
    <drawer-menu />
    <v-toolbar 
      color="accent" 
      class="white--text" 
      app>
      <v-toolbar-side-icon @click="$store.state.drawer = !$store.state.drawer">
        <v-icon color="white">menu</v-icon>
      </v-toolbar-side-icon>
      <v-layout column>
        <span 
          v-for="item in $route.name.split(' ')" 
          :key="item.index" 
          class="title">
          {{ item }}
        </span>
      </v-layout>
      <v-spacer/>
      <!-- <v-btn @click="print"></v-btn> -->
      <v-toolbar-items>
        <v-btn 
          flat 
          class="pr-0 white--text" 
          @click="$store.state.usermenu = true">
          <v-layout column>
            <span 
              v-for="item in $store.state.selected_user.split(' ')" 
              :key="item.index">
              {{ item }}
            </span>
          </v-layout>
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <drawer-user />
  </div>
</template>
<script>
export default {
	methods: {
		print() {
			console.log(this.$store.state)
		}
	}
}
</script>
